/**
 * simple anchor link scrolling
 */
jQuery(function($){
    // see scss: anchor-offset
    $('.goto-anchor').click(function(e) {
        e.preventDefault();
        var anchor = $(this).data('anchor');
        var dest = anchor ? '#' + anchor : $(this).attr('href');
        $('html,body').animate({ scrollTop: $(dest).offset().top }, 'slow');
    });
});
